/**
 * @author mrdoob / http://mrdoob.com/
 */

import UI from './libs/ui'

function buildButtonComponent (componentName) {
  return new UI.Button(componentName)
    .setWidth('72%')
    .setPadding('10px 0')
    .setBorderRadius('8px')
    .setBackgroundColor('#121212')
}

var SelectorNodeTab = function (editor) {
  var signals = editor.signals
  var container = new UI.Panel()
  container.setId('selectorNode')
  container.setTextAlign('center')

  var selected = null

  function build () {
    container.clear()
    if (selected === null) return

    var character = new UI.Row()
    var characterButton = buildButtonComponent('Character')
    characterButton.onClick(onSelectedNodeType)
    character.add(characterButton)
    container.add(character)

    var environment3D = new UI.Row()
    var environment3DButton = buildButtonComponent('3D Environment')
    environment3DButton.onClick(onSelectedNodeType)
    environment3D.add(environment3DButton)
    container.add(environment3D)

    var experience = new UI.Row()
    var experienceButton = buildButtonComponent('Experience')
    experienceButton.onClick(onSelectedNodeType)
    experience.add(experienceButton)
    container.add(experience)

    var sound = new UI.Row()
    var soundButton = buildButtonComponent('Sound')
    soundButton.onClick(onSelectedNodeType)
    sound.add(soundButton)
    container.add(sound)

    var UI2D = new UI.Row()
    var UI2DButton = buildButtonComponent('2D UI')
    UI2DButton.onClick(onSelectedNodeType)
    UI2D.add(UI2DButton)
    container.add(UI2D)

    var icon2D = new UI.Row()
    var icon2DButton = buildButtonComponent('2D Icon')
    icon2DButton.onClick(onSelectedNodeType)
    icon2D.add(icon2DButton)
    container.add(icon2D)

    var prop = new UI.Row()
    var propButton = buildButtonComponent('Prop')
    propButton.onClick(onSelectedNodeType)
    prop.add(propButton)
    container.add(prop)
  }

  function onSelectedNodeType () {
    selected.name = this.dom.innerText
    selected.type = selected.name
    selected.phase = 'needsAsset'
    signals.animationPhaseChanged.dispatch(selected)
    signals.animationRenamed.dispatch(selected)
  }

  //
  // signals.editorCleared.add( function () {
  //   selected = null
  //   build()
  // } );

  signals.animationSelected.add(function (animation) {
    selected = animation
    build()
  })

  signals.effectCompiled.add(build)

  return container
}

export default SelectorNodeTab



//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/SelectorNodeTab.js
// module id = null
// module chunks = 